import { everest } from '~/services/serviceInstances';

import { DeleteRoutingApiArg } from '../../types/routings/routes';

type Request = DeleteRoutingApiArg;

export const deleteRouting = async ({ routingId }: Request): Promise<void> => {
  await everest.remove(`/routing/${routingId}`);
};
